module.exports = __webpack_public_path__ + "media/03 stilt.ff2a9c1c.mp3";